import { Box, Grid, Link, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import CustomTextField from 'components/Input/CustomTextField';
import CustomButton from 'components/CustomInput/Button/index';
import { useSelector } from 'react-redux';
import MsgBox from 'components/MsgBox/MsgBox';
import API from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';

function ForgotPasswordLayout(props) {
    const { setPageComponent, showLoginLayout } = props;

    const systemMessage = useSelector((state) => state.systemMessage.systemMessage);

    const [warningMsg, setWarningMsg] = useState(null);

    const [email, setEmail] = useState('');

    const [emailValid, setEmailValid] = useState(false);
    const [forceShowError, setForceShowError] = useState(false);

    const handleResetPasswordClick = (e) => {
        //check validation, if no, show error text and cant send reset email
        setForceShowError(true);
        if (email && emailValid) {
            setGlobalLoading(true);
            API.user
                .forgetPassword({ email: email })
                .then((res) => {
                    setWarningMsg({
                        type: 'confirm',
                        message: systemMessage.sendEmail_001,
                        footerActions: [
                            {
                                label: 'Confirm',
                                clicked: () => {
                                    setWarningMsg(null);
                                    handleSignInClick();
                                },
                            },
                        ],
                    });
                })
                .catch((err) => {
                    console.log('err', err);
                })
                .finally(() => {
                    setGlobalLoading(false);
                });
        }
    };

    const handleSignInClick = (e) => {
        setPageComponent(showLoginLayout);
    };

    return (
        <>
            {warningMsg && (
                <MsgBox
                    type={warningMsg.type}
                    message={warningMsg.message}
                    footerActions={warningMsg.footerActions}
                    title={warningMsg.title}
                    closePopup={() => setWarningMsg(null)}
                />
            )}
            <Box my={1}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h4" style={{ fontSize: 18, fontWeight: 'bold' }}>
                            Forgot Password?
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <CustomTextField
                            validators={['isRequired', 'isEmail', 'disableChinese']}
                            isValidValue={(valid) => setEmailValid(valid)}
                            forceErrorDisplay={forceShowError}
                            label="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            maxLength={255}
                            isNoSpace
                            showErrorWhenOnBlur
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomButton fullWidth onClick={handleResetPasswordClick}>
                            Reset password
                        </CustomButton>
                    </Grid>
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography>
                            Already have login and password?{' '}
                            <Link href="#" onClick={handleSignInClick}>
                                Sign in
                            </Link>
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default ForgotPasswordLayout;
